const backButton = document.querySelector('a.back-button')

if (backButton) {
  backButton.addEventListener('click', (e) => {
    e.preventDefault()
    window.history.back()
  })
}
